"use strict";
/**
 * To update enum/file run next SQL command in data-drip. needs to close gap in line 7 between * and /

 select CONCAT('export enum WbfPolicies {',actor_list,'}') as copy_me
 from (SELECT 1, string_agg(CONCAT('  /**
 ', description, '
 * /
 ','"', name, '"', ' = ', '"', name, '"'), ', ') AS actor_list
 FROM policy
 GROUP BY 1) as list;

 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WbfPolicies = void 0;
// <GENERATED
var WbfPolicies;
(function (WbfPolicies) {
    /**
   Allow to get Enrollment Statuses on External Endpoint
   */ WbfPolicies["is_get_enrollment_status_enabled"] = "is_get_enrollment_status_enabled";
    /**
   Show metlifeId in the single person page
   */ WbfPolicies["is_show_metlifeId_enabled"] = "is_show_metlifeId_enabled";
    /**
   Allow worker to get appointments
   */ WbfPolicies["is_get_worker_appointments_enabled"] = "is_get_worker_appointments_enabled";
    /**
   Allow worker to create appointment
   */ WbfPolicies["is_create_worker_appointment_enabled"] = "is_create_worker_appointment_enabled";
    /**
   Allow worker to get appointment
   */ WbfPolicies["is_get_worker_appointment_enabled"] = "is_get_worker_appointment_enabled";
    /**
   Allow to display team lead hub tab.
   */ WbfPolicies["is_team_lead_hub_tab_enabled"] = "is_team_lead_hub_tab_enabled";
    /**
   Allow to manage clinics.
   */ WbfPolicies["is_clinic_management_enabled"] = "is_clinic_management_enabled";
    /**
   Allow to display clinics.
   */ WbfPolicies["is_clinics_enabled"] = "is_clinics_enabled";
    /**
   Allow to get tasks for a given person id
   */ WbfPolicies["is_get_task_by_person_id_enabled"] = "is_get_task_by_person_id_enabled";
    /**
   Allow deletion of form attachments
   */ WbfPolicies["is_remove_form_attachment_enabled"] = "is_remove_form_attachment_enabled";
    /**
   Allow to get escalation by id
   */ WbfPolicies["is_get_escalation_by_id_enabled"] = "is_get_escalation_by_id_enabled";
    /**
   Allow worker to update escalation
   */ WbfPolicies["is_update_escalation_enabled"] = "is_update_escalation_enabled";
    /**
   Allow worker to create escalation
   */ WbfPolicies["is_create_escalation_enabled"] = "is_create_escalation_enabled";
    /**
   Should control the ability to actually open the PFML form submission
   */ WbfPolicies["is_wastate_open_form_enabled"] = "is_wastate_open_form_enabled";
    /**
   Allow to see the Escalations tab in the left menu
   */ WbfPolicies["is_escalations_table_enabled"] = "is_escalations_table_enabled";
    /**
   Allow to see all escalations
   */ WbfPolicies["is_get_all_escalations_enabled"] = "is_get_all_escalations_enabled";
    /**
   Allows open forms in the form submission widget
   */ WbfPolicies["is_open_form_submission_enabled"] = "is_open_form_submission_enabled";
    /**
   is_create_location_enabled
   */ WbfPolicies["is_create_location_enabled"] = "is_create_location_enabled";
    /**
   is_delete_location_by_id_enabled
   */ WbfPolicies["is_delete_location_by_id_enabled"] = "is_delete_location_by_id_enabled";
    /**
   is_update_location_by_id_enabled
   */ WbfPolicies["is_update_location_by_id_enabled"] = "is_update_location_by_id_enabled";
    /**
   Allow access to the vendors page
   */ WbfPolicies["is_enrollment_checker_vendors_enabled"] = "is_enrollment_checker_vendors_enabled";
    /**
   Allow deletion of a task and its associated form and chat messages
   */ WbfPolicies["is_delete_task_by_id_enabled"] = "is_delete_task_by_id_enabled";
    /**
   Allow deletion of an escalation and its associated form, attachments and chat messages
   */ WbfPolicies["is_delete_escalation_by_id_enabled"] = "is_delete_escalation_by_id_enabled";
    /**
   Allow to show the tasks widget in the single person page
   */ WbfPolicies["is_task_widget_enabled"] = "is_task_widget_enabled";
    /**
   Allow user to get all the context of a person by id
   */ WbfPolicies["is_get_all_person_context_enabled"] = "is_get_all_person_context_enabled";
    /**
   Allow to see gig work functionality
   */ WbfPolicies["is_gig_work_enabled"] = "is_gig_work_enabled";
    /**
   Allow to see finances functionality
   */ WbfPolicies["is_finances_enabled"] = "is_finances_enabled";
    /**
   Allow to generate basic tax report
   */ WbfPolicies["is_send_worker_basic_tax_report_enabled"] = "is_send_worker_basic_tax_report_enabled";
    /**
   Allow user to create itself in plaid service
   */ WbfPolicies["is_enable_create_new_plaid_user"] = "is_enable_create_new_plaid_user";
    /**
   Allow user to link a new gig account
   */ WbfPolicies["is_enable_link_plaid_gig_account"] = "is_enable_link_plaid_gig_account";
    /**
   Allow user to get all plaid accounts by user id
   */ WbfPolicies["is_enable_get_all_plaid_account_by_user_id"] = "is_enable_get_all_plaid_account_by_user_id";
    /**
   Allow user to get all plaid transactions by user id
   */ WbfPolicies["is_enable_get_all_plaid_transactions_by_user_id"] = "is_enable_get_all_plaid_transactions_by_user_id";
    /**
   Allow user delete a person note
   */ WbfPolicies["is_remove_person_note_enabled"] = "is_remove_person_note_enabled";
    /**
   Allow user delete a chat message except for person notes
   */ WbfPolicies["is_remove_chat_message_enabled"] = "is_remove_chat_message_enabled";
    /**
   Allow user edit a chat message except for person notes
   */ WbfPolicies["is_update_chat_message_enabled"] = "is_update_chat_message_enabled";
    /**
   Allow user all notes messages
   */ WbfPolicies["is_get_person_all_notes_enabled"] = "is_get_person_all_notes_enabled";
    /**
   Allow to use W360 Portal
   */ WbfPolicies["is_w360_enabled"] = "is_w360_enabled";
    /**
   Allow to use U360 Mobile App
   */ WbfPolicies["is_u360_enabled"] = "is_u360_enabled";
    /**
   Allow to see Rating
   */ WbfPolicies["is_rating_enabled"] = "is_rating_enabled";
    /**
   Allow to see Tickets/Office Visits
   */ WbfPolicies["is_tickets_enabled"] = "is_tickets_enabled";
    /**
   Allow to add new user to Current Org.
   */ WbfPolicies["is_add_new_user_enabled"] = "is_add_new_user_enabled";
    /**
   Allow to see SMS Campaigns
   */ WbfPolicies["is_sms_campaigns_enabled"] = "is_sms_campaigns_enabled";
    /**
   Allow to see Tasks
   */ WbfPolicies["is_tasks_enabled"] = "is_tasks_enabled";
    /**
   Allow creating new Form Templates
   */ WbfPolicies["is_create_form_template_enabled"] = "is_create_form_template_enabled";
    /**
   Allow updating new Form Templates
   */ WbfPolicies["is_update_form_template_enabled"] = "is_update_form_template_enabled";
    /**
   Allow creating new Membership Email Domains
   */ WbfPolicies["is_create_membership_email_domain_enabled"] = "is_create_membership_email_domain_enabled";
    /**
   Allow to see Leads
   */ WbfPolicies["is_get_leads_enabled"] = "is_get_leads_enabled";
    /**
   Allow to see Accounts
   */ WbfPolicies["is_get_accounts_enabled"] = "is_get_accounts_enabled";
    /**
   Allow to create Lead
   */ WbfPolicies["is_create_person_enabled"] = "is_create_person_enabled";
    /**
   Allow to convert Lead
   */ WbfPolicies["is_enrollment_verification_enabled"] = "is_enrollment_verification_enabled";
    /**
   Allow Admins to add new user to any Org.
   */ WbfPolicies["is_add_new_user_to_organization_enabled"] = "is_add_new_user_to_organization_enabled";
    /**
   Allow to see the list of user-available organizations. (Allow for all)
   */ WbfPolicies["is_get_auth_organizations_enabled"] = "is_get_auth_organizations_enabled";
    /**
   Allow to see the current user profile. (Allow for all)
   */ WbfPolicies["is_get_auth_profile_enabled"] = "is_get_auth_profile_enabled";
    /**
   TBD
   */ WbfPolicies["is_eligibilities_data_loader_metlife_external_id_bulk_update_enabled"] = "is_eligibilities_data_loader_metlife_external_id_bulk_update_enabled";
    /**
   TBD
   */ WbfPolicies["is_eligibilities_data_loader_metlife_external_id_bulk_update_memory_enabled"] = "is_eligibilities_data_loader_metlife_external_id_bulk_update_memory_enabled";
    /**
   TBD
   */ WbfPolicies["is_eligibilities_data_loader_metlife_external_id_bulk_update_memory_optimized_d_b_response_enabled"] = "is_eligibilities_data_loader_metlife_external_id_bulk_update_memory_optimized_d_b_response_enabled";
    /**
   TBD
   */ WbfPolicies["is_washington_state_build_report_enabled"] = "is_washington_state_build_report_enabled";
    /**
   Allow to create a policy
   */ WbfPolicies["is_create_policy_enabled"] = "is_create_policy_enabled";
    /**
   Allow to update a person tags
   */ WbfPolicies["is_update_person_tags_enabled"] = "is_update_person_tags_enabled";
    /**
   Allow to run DU to WBF synchronization
   */ WbfPolicies["is_drivers_union_run_sync_nb_to_wbf_enabled"] = "is_drivers_union_run_sync_nb_to_wbf_enabled";
    /**
   Allow to restore a dependent benestream person
   */ WbfPolicies["is_restore_benestream_person_dependent_enabled"] = "is_restore_benestream_person_dependent_enabled";
    /**
   Allow to process gvs benefit utilization record
   */ WbfPolicies["is_process_gvs_benefit_utilization_file_enabled"] = "is_process_gvs_benefit_utilization_file_enabled";
    /**
   Allow to updated hippa certified flag in users
   */ WbfPolicies["is_update_hipaa_certified_enabled"] = "is_update_hipaa_certified_enabled";
    /**
   Allow to edit dependents
   */ WbfPolicies["is_update_benestream_person_dependent_enabled"] = "is_update_benestream_person_dependent_enabled";
    /**
   Allow to see person enrollments
   */ WbfPolicies["is_get_person_enrollments_enabled"] = "is_get_person_enrollments_enabled";
    /**
   Allow to auto-generate fake person email
   */ WbfPolicies["is_generate_person_email_enabled"] = "is_generate_person_email_enabled";
    /**
   Allow to see all scheduler cron jobs
   */ WbfPolicies["is_get_all_scheduler_cron_jobs_enabled"] = "is_get_all_scheduler_cron_jobs_enabled";
    /**
   Allow to deactivate aircall webhook
   */ WbfPolicies["is__aircall_deactivate_webhook_enabled"] = "is__aircall_deactivate_webhook_enabled";
    /**
   Allow to create bstm person using Data Loader
   */ WbfPolicies["is_benestream_person_data_loader_create_benestream_from_csv_enabled"] = "is_benestream_person_data_loader_create_benestream_from_csv_enabled";
    /**
   Allow to update user membership
   */ WbfPolicies["is_update_user_membership_enabled"] = "is_update_user_membership_enabled";
    /**
   Allow to process and update elegibilities from csv using Data Loader
   */ WbfPolicies["is_process_and_update_eligibilities_data_loader_from_csv_enabled"] = "is_process_and_update_eligibilities_data_loader_from_csv_enabled";
    /**
   Allow to create ally health benefit utilization
   */ WbfPolicies["is_create_ally_health_benefit_utilization_enabled"] = "is_create_ally_health_benefit_utilization_enabled";
    /**
   Allow to reactivate aircall webhook
   */ WbfPolicies["is__aircall_reactivate_webhook_enabled"] = "is__aircall_reactivate_webhook_enabled";
    /**
   Allow to see benestream eligibility guideline
   */ WbfPolicies["is_get_benestream_eligibility_guideline_enabled"] = "is_get_benestream_eligibility_guideline_enabled";
    /**
   Allow to see email templates by user
   */ WbfPolicies["is_get_email_templates_by_user_enabled"] = "is_get_email_templates_by_user_enabled";
    /**
   Allow to see a person tags
   */ WbfPolicies["is_get_person_tags_enabled"] = "is_get_person_tags_enabled";
    /**
   Allow to delete depedents
   */ WbfPolicies["is_delete_benestream_person_dependent_enabled"] = "is_delete_benestream_person_dependent_enabled";
    /**
   Allow to see an email template by id
   */ WbfPolicies["is_get_email_template_by_id_enabled"] = "is_get_email_template_by_id_enabled";
    /**
   Allow to add users to organizations
   */ WbfPolicies["is_add_user_to_organization_enabled"] = "is_add_user_to_organization_enabled";
    /**
   Allow to create eligibility
   */ WbfPolicies["is_create_eligibility_enabled"] = "is_create_eligibility_enabled";
    /**
   Allow to send sms
   */ WbfPolicies["is_send_s_m_s_enabled"] = "is_send_s_m_s_enabled";
    /**
   Allow to see person's history by id
   */ WbfPolicies["is_get_persons_history_by_id_enabled"] = "is_get_persons_history_by_id_enabled";
    /**
   Allow to update an appointment
   */ WbfPolicies["is_update_appointment_enabled"] = "is_update_appointment_enabled";
    /**
   Allow to run ally health reconciliation
   */ WbfPolicies["is_run_ally_health_reconciliation_enabled"] = "is_run_ally_health_reconciliation_enabled";
    /**
   Allow the enrollments deactivation process
   */ WbfPolicies["is_enrollments_deactivation_process_enabled"] = "is_enrollments_deactivation_process_enabled";
    /**
   Allow to deactivate an enrollment
   */ WbfPolicies["is_deactivate_enrollment_enabled"] = "is_deactivate_enrollment_enabled";
    /**
   Allow to see person eligibilities
   */ WbfPolicies["is_get_person_eligibilities_enabled"] = "is_get_person_eligibilities_enabled";
    /**
   Allow to create ally health benefit utilization from file
   */ WbfPolicies["is_create_ally_health_benefit_utilization_from_file_enabled"] = "is_create_ally_health_benefit_utilization_from_file_enabled";
    /**
   Allow to see benefits by associated benefit contract id
   */ WbfPolicies["is_get_benefits_by_associated_benefit_contract_id_enabled"] = "is_get_benefits_by_associated_benefit_contract_id_enabled";
    /**
   Allow to see eligibility history
   */ WbfPolicies["is_get_eligibility_history_enabled"] = "is_get_eligibility_history_enabled";
    /**
   Allow to see the task commmunications history
   */ WbfPolicies["is_get_task_communications_history_enabled"] = "is_get_task_communications_history_enabled";
    /**
   Allow to see office visits
   */ WbfPolicies["is_get_office_visits_enabled"] = "is_get_office_visits_enabled";
    /**
   Allow to find existing person
   */ WbfPolicies["is_find_existing_person_enabled"] = "is_find_existing_person_enabled";
    /**
   Allow to generate pre signed url for enrollment attachments
   */ WbfPolicies["is_generate_pre_signed_url_for_enrollment_attachments_enabled"] = "is_generate_pre_signed_url_for_enrollment_attachments_enabled";
    /**
   Allow to see a voice mail
   */ WbfPolicies["is_get_voice_mail_enabled"] = "is_get_voice_mail_enabled";
    /**
   Allow to create multiple tasks
   */ WbfPolicies["is_create_multiple_task_enabled"] = "is_create_multiple_task_enabled";
    /**
   Allow to see appointmets by person id
   */ WbfPolicies["is_get_appointments_by_person_id_enabled"] = "is_get_appointments_by_person_id_enabled";
    /**
   Allows the restoration of deleted documents from the trash bin.
   */ WbfPolicies["is_restore_document_enabled"] = "is_restore_document_enabled";
    /**
   Allow to see persons by id
   */ WbfPolicies["is_get_person_by_id_enabled"] = "is_get_person_by_id_enabled";
    /**
   Allow to see all organizations
   */ WbfPolicies["is_get_all_organisations_enabled"] = "is_get_all_organisations_enabled";
    /**
   Allow to update form
   */ WbfPolicies["is_update_form_enabled"] = "is_update_form_enabled";
    /**
   Allow to create cms benefit
   */ WbfPolicies["is_create_cms_benefit_enabled"] = "is_create_cms_benefit_enabled";
    /**
   Allow to see the Lyft persons
   */ WbfPolicies["is_get_lyft_persons_enabled"] = "is_get_lyft_persons_enabled";
    /**
   Allow to see form templates by id
   */ WbfPolicies["is_get_form_templates_by_id_enabled"] = "is_get_form_templates_by_id_enabled";
    /**
   Allow to see all ally health benefit utilization
   */ WbfPolicies["is_get_all_ally_health_benefit_utilization_members_enabled"] = "is_get_all_ally_health_benefit_utilization_members_enabled";
    /**
   Allow to see a benestream person by id
   */ WbfPolicies["is_get_benestream_person_by_id_enabled"] = "is_get_benestream_person_by_id_enabled";
    /**
   Allow to update organization
   */ WbfPolicies["is_update_organization_enabled"] = "is_update_organization_enabled";
    /**
   Allow to update document
   */ WbfPolicies["is_update_document_enabled"] = "is_update_document_enabled";
    /**
   Allow to see form
   */ WbfPolicies["is_get_form_enabled"] = "is_get_form_enabled";
    /**
   Allow to see app information
   */ WbfPolicies["is_get_app_info_enabled"] = "is_get_app_info_enabled";
    /**
   Allow to create task
   */ WbfPolicies["is_create_task_enabled"] = "is_create_task_enabled";
    /**
   Allow to process and update enrollments data from csv using Data Loader
   */ WbfPolicies["is_process_and_update_enrollments_data_loader_from_csv_enabled"] = "is_process_and_update_enrollments_data_loader_from_csv_enabled";
    /**
   Allow to see associated benefit contracts by organization id
   */ WbfPolicies["is_get_associated_benefit_contracts_by_organization_id_enabled"] = "is_get_associated_benefit_contracts_by_organization_id_enabled";
    /**
   Allow to start sendgrid process reconciliation
   */ WbfPolicies["is_start_sendgrid_reconciliation_process_enabled"] = "is_start_sendgrid_reconciliation_process_enabled";
    /**
   Allow to create chats
   */ WbfPolicies["is_create_chat_enabled"] = "is_create_chat_enabled";
    /**
   Allow to see a role
   */ WbfPolicies["is_get_role_enabled"] = "is_get_role_enabled";
    /**
   Allow to see appoitments
   */ WbfPolicies["is_get_appointment_enabled"] = "is_get_appointment_enabled";
    /**
   Allow to see black car fund tags
   */ WbfPolicies["is_get_black_car_fund_tags_enabled"] = "is_get_black_car_fund_tags_enabled";
    /**
   Allow to update voice mail
   */ WbfPolicies["is_update_voice_mail_enabled"] = "is_update_voice_mail_enabled";
    /**
   Allow to update benestream person using Data Loader
   */ WbfPolicies["is_benestream_person_data_loader_enabled"] = "is_benestream_person_data_loader_enabled";
    /**
   Allow to reactivate an enrollment
   */ WbfPolicies["is_reactivate_enrollment_enabled"] = "is_reactivate_enrollment_enabled";
    /**
   Allow to remove cms benefit
   */ WbfPolicies["is_remove_cms_benefit_enabled"] = "is_remove_cms_benefit_enabled";
    /**
   Allow to see email domains
   */ WbfPolicies["is_get_all_email_domains_enabled"] = "is_get_all_email_domains_enabled";
    /**
   Allow to generate cms benefit for a pre signed url
   */ WbfPolicies["is_generate_cms_benefit_pre_signed_url_enabled"] = "is_generate_cms_benefit_pre_signed_url_enabled";
    /**
   Allow to see associated benefit contracts by name
   */ WbfPolicies["is_get_associated_benefit_contracts_by_name_enabled"] = "is_get_associated_benefit_contracts_by_name_enabled";
    /**
   Allow to see benestream elegibility guideline by state abbreviation
   */ WbfPolicies["is_get_benestream_eligibility_guideline_by_state_abbreviation_enabled"] = "is_get_benestream_eligibility_guideline_by_state_abbreviation_enabled";
    /**
   Allow to create a call
   */ WbfPolicies["is_create_call_enabled"] = "is_create_call_enabled";
    /**
   Allow to remove user membership
   */ WbfPolicies["is_remove_membership_enabled"] = "is_remove_membership_enabled";
    /**
   Allow to see sms by campaign id
   */ WbfPolicies["is_get_s_m_s_by_campaign_id_enabled"] = "is_get_s_m_s_by_campaign_id_enabled";
    /**
   Allow to see metroplus reps
   */ WbfPolicies["is_get_metroplus_reps_enabled"] = "is_get_metroplus_reps_enabled";
    /**
   Allow to update cms benefit
   */ WbfPolicies["is_update_cms_benefit_enabled"] = "is_update_cms_benefit_enabled";
    /**
   Allow to add notes
   */ WbfPolicies["is_add_person_note_enabled"] = "is_add_person_note_enabled";
    /**
   Allow to see organization
   */ WbfPolicies["is_get_organisation_enabled"] = "is_get_organisation_enabled";
    /**
   Allow to see chat messages
   */ WbfPolicies["is_get_chat_messages_enabled"] = "is_get_chat_messages_enabled";
    /**
   Allow to see a black car fund person tags
   */ WbfPolicies["is_get_person_tags_black_car_fund_enabled"] = "is_get_person_tags_black_car_fund_enabled";
    /**
   Allow bstm user to upload data from CSV - Data Loader
   */ WbfPolicies["is_benestream_person_data_loader_create_from_csv_enabled"] = "is_benestream_person_data_loader_create_from_csv_enabled";
    /**
   Allow to see sms campaigns
   */ WbfPolicies["is_get_s_m_s_campaigns_enabled"] = "is_get_s_m_s_campaigns_enabled";
    /**
   Allow to process all metlife benefit utilization records
   */ WbfPolicies["is_process_all_metlife_benefit_utilization_records_enabled"] = "is_process_all_metlife_benefit_utilization_records_enabled";
    /**
   Allow to generate metroplus transfer id
   */ WbfPolicies["is_get_metro_plus_send_to_by_person_id_enabled"] = "is_get_metro_plus_send_to_by_person_id_enabled";
    /**
   Allow to delete DU person
   */ WbfPolicies["is_delete_d_u_person_enabled"] = "is_delete_d_u_person_enabled";
    /**
   Allow to see membership email domain by id
   */ WbfPolicies["is_get_membership_email_domain_by_id_enabled"] = "is_get_membership_email_domain_by_id_enabled";
    /**
   Allow to update email domains
   */ WbfPolicies["is_update_email_domain_enabled"] = "is_update_email_domain_enabled";
    /**
   Allow to see all DMP cases
   */ WbfPolicies["is_get_all_d_m_p_cases_enabled"] = "is_get_all_d_m_p_cases_enabled";
    /**
   Allow to create form template
   */ WbfPolicies["is_crete_form_template_enabled"] = "is_crete_form_template_enabled";
    /**
   Allow to upload data from CSV - Data Loader
   */ WbfPolicies["is_persons_data_loader_create_from_csv_enabled"] = "is_persons_data_loader_create_from_csv_enabled";
    /**
   Allow to see person income
   */ WbfPolicies["is_get_benestream_person_income_enabled"] = "is_get_benestream_person_income_enabled";
    /**
   Allow to sync mailchimp with all audiences
   */ WbfPolicies["is_sync_mailchimp_all_audiences_enabled"] = "is_sync_mailchimp_all_audiences_enabled";
    /**
   Allow to delete benestream eligibilty guidelines
   */ WbfPolicies["is_remove_benestream_eligibility_guideline_enabled"] = "is_remove_benestream_eligibility_guideline_enabled";
    /**
   Allow to see benestream eligibility guidelines
   */ WbfPolicies["is_get_benestream_eligibility_guidelines_enabled"] = "is_get_benestream_eligibility_guidelines_enabled";
    /**
   Allow to update bstm person using Data Loader
   */ WbfPolicies["is_benestream_person_data_loader_update_enabled"] = "is_benestream_person_data_loader_update_enabled";
    /**
   Allow to add dependents to a person
   */ WbfPolicies["is_create_benestream_person_dependent_enabled"] = "is_create_benestream_person_dependent_enabled";
    /**
   Allow to remove email templates
   */ WbfPolicies["is_remove_email_template_enabled"] = "is_remove_email_template_enabled";
    /**
   Allow to generate elegibilities url using data loader
   */ WbfPolicies["is_generate_eligibilities_data_loader_upload_url_enabled"] = "is_generate_eligibilities_data_loader_upload_url_enabled";
    /**
   Allow to see an email domain by id
   */ WbfPolicies["is_get_email_domain_by_id_enabled"] = "is_get_email_domain_by_id_enabled";
    /**
   Allow to terminate ally health benefit utilization member
   */ WbfPolicies["is_terminate_ally_health_benefit_utilization_member_enabled"] = "is_terminate_ally_health_benefit_utilization_member_enabled";
    /**
   Allow to create chat messages
   */ WbfPolicies["is_create_chat_message_enabled"] = "is_create_chat_message_enabled";
    /**
   Allow to update a policy
   */ WbfPolicies["is_update_policy_enabled"] = "is_update_policy_enabled";
    /**
   Allow to create appointments
   */ WbfPolicies["is_create_appointment_enabled"] = "is_create_appointment_enabled";
    /**
   Allow to see organization users
   */ WbfPolicies["is_get_organisation_users_enabled"] = "is_get_organisation_users_enabled";
    /**
   Allow to update an enrollment
   */ WbfPolicies["is_update_enrollment_enabled"] = "is_update_enrollment_enabled";
    /**
   Allow to get the user information
   */ WbfPolicies["is_get_user_by_id_enabled"] = "is_get_user_by_id_enabled";
    /**
   Allow to update person using Data Loader
   */ WbfPolicies["is_persons_data_loader_update_enabled"] = "is_persons_data_loader_update_enabled";
    /**
   Allow to send sms campaigns
   */ WbfPolicies["is_send_sms_campaign_enabled"] = "is_send_sms_campaign_enabled";
    /**
   Allow to tag an aircall call
   */ WbfPolicies["is_tag_aircall_call_enabled"] = "is_tag_aircall_call_enabled";
    /**
   Allow to process all gvs benefit utilization records
   */ WbfPolicies["is_process_all_gvs_benefit_utilization_records_enabled"] = "is_process_all_gvs_benefit_utilization_records_enabled";
    /**
   Allow to generate API Keys
   */ WbfPolicies["is_generate_auth_api_key_enabled"] = "is_generate_auth_api_key_enabled";
    /**
   Allow to see an email by id
   */ WbfPolicies["is_get_email_by_id_enabled"] = "is_get_email_by_id_enabled";
    /**
   Allow to see elegibilities url using data loader
   */ WbfPolicies["is_get_eligibilities_data_loader_url_enabled"] = "is_get_eligibilities_data_loader_url_enabled";
    /**
   Allow to update users
   */ WbfPolicies["is_update_user_enabled"] = "is_update_user_enabled";
    /**
   Allow to see the calls list
   */ WbfPolicies["is_get_calls_list_enabled"] = "is_get_calls_list_enabled";
    /**
   Allow to see enrollments url using Data Loader
   */ WbfPolicies["is_get_enrollments_data_loader_url_enabled"] = "is_get_enrollments_data_loader_url_enabled";
    /**
   Allow to see eligibility by id
   */ WbfPolicies["is_get_eligibility_by_id_enabled"] = "is_get_eligibility_by_id_enabled";
    /**
   Allow to see the DMP case history
   */ WbfPolicies["is_get_d_m_p_case_history_enabled"] = "is_get_d_m_p_case_history_enabled";
    /**
   Allow to create new organization
   */ WbfPolicies["is_create_organization_enabled"] = "is_create_organization_enabled";
    /**
   Allow to see communications history
   */ WbfPolicies["is_get_communications_history_enabled"] = "is_get_communications_history_enabled";
    /**
   Allow to see and use nyc lookup
   */ WbfPolicies["is_nyc_lookup_enabled"] = "is_nyc_lookup_enabled";
    /**
   Allow to process and create enrollments from csv file using Data Loader
   */ WbfPolicies["is_process_and_create_enrollments_data_loader_csv_file_enabled"] = "is_process_and_create_enrollments_data_loader_csv_file_enabled";
    /**
   Allow to see the emails attachment url
   */ WbfPolicies["is_get_emails_attachment_url_enabled"] = "is_get_emails_attachment_url_enabled";
    /**
   Allow to create a voicemail
   */ WbfPolicies["is_create_voice_mail_enabled"] = "is_create_voice_mail_enabled";
    /**
   Allow to see a DMP case
   */ WbfPolicies["is_get_d_m_p_case_enabled"] = "is_get_d_m_p_case_enabled";
    /**
   Allow to update an office visit
   */ WbfPolicies["is_update_office_visit_enabled"] = "is_update_office_visit_enabled";
    /**
   Allow to see office visits by organization id
   */ WbfPolicies["is_get_office_visits_by_organization_id_enabled"] = "is_get_office_visits_by_organization_id_enabled";
    /**
   Allow to see office visits by person id
   */ WbfPolicies["is_get_office_visits_by_person_id_enabled"] = "is_get_office_visits_by_person_id_enabled";
    /**
   Allow to process and update enrollments data from csv file using Data Loader
   */ WbfPolicies["is_process_and_update_enrollments_data_loader_csv_file_enabled"] = "is_process_and_update_enrollments_data_loader_csv_file_enabled";
    /**
   Allow to see persons
   */ WbfPolicies["is_update_person_enabled"] = "is_update_person_enabled";
    /**
   Allow to see aircall users
   */ WbfPolicies["is_get_aircall_users_enabled"] = "is_get_aircall_users_enabled";
    /**
   Allow to delete document
   */ WbfPolicies["is_delete_document_enabled"] = "is_delete_document_enabled";
    /**
   Allow to see forms
   */ WbfPolicies["is_get_forms_enabled"] = "is_get_forms_enabled";
    /**
   Allow to remove membership email domain
   */ WbfPolicies["is_remove_membership_email_domain_enabled"] = "is_remove_membership_email_domain_enabled";
    /**
   Allow to assign person to user
   */ WbfPolicies["is_assign_person_to_user_enabled"] = "is_assign_person_to_user_enabled";
    /**
   Allow to create a primary benestream person
   */ WbfPolicies["is_create_benestream_person_primary_enabled"] = "is_create_benestream_person_primary_enabled";
    /**
   Allow to see an appointment by id
   */ WbfPolicies["is_get_appointment_by_id_enabled"] = "is_get_appointment_by_id_enabled";
    /**
   Allow to verify an enrollment
   */ WbfPolicies["is_verify_enrollment_enabled"] = "is_verify_enrollment_enabled";
    /**
   Allow to create benestream eligibilty guidelines
   */ WbfPolicies["is_create_benestream_eligibility_guideline_enabled"] = "is_create_benestream_eligibility_guideline_enabled";
    /**
   DEPRECATED - Will be deleted
   */ WbfPolicies["is_persons_data_loader_get_url_enabled"] = "is_persons_data_loader_get_url_enabled";
    /**
   Allow to see all DMP cases by email
   */ WbfPolicies["is_get_all_d_m_p_cases_by_email_enabled"] = "is_get_all_d_m_p_cases_by_email_enabled";
    /**
   Allow to deactivate an eligibility
   */ WbfPolicies["is_deactivate_eligibility_enabled"] = "is_deactivate_eligibility_enabled";
    /**
   Allow to create a document
   */ WbfPolicies["is_create_document_enabled"] = "is_create_document_enabled";
    /**
   Allow to see organizations forms
   */ WbfPolicies["is_get_organization_forms_enabled"] = "is_get_organization_forms_enabled";
    /**
   Allow to update a primary benestream person
   */ WbfPolicies["is_update_benestream_person_primary_enabled"] = "is_update_benestream_person_primary_enabled";
    /**
   Allow to generate emails upload url
   */ WbfPolicies["is_generate_emails_upload_url_enabled"] = "is_generate_emails_upload_url_enabled";
    /**
   Allow to process metlife benefit utilization
   */ WbfPolicies["is_process_metlife_benefit_utilization_file_enabled"] = "is_process_metlife_benefit_utilization_file_enabled";
    /**
   Allow to run scheduler cron job
   */ WbfPolicies["is_run_scheduler_cron_job_enabled"] = "is_run_scheduler_cron_job_enabled";
    /**
   Allow to update a black car fund person tags
   */ WbfPolicies["is_update_person_black_car_found_tags_enabled"] = "is_update_person_black_car_found_tags_enabled";
    /**
   Allow to update task
   */ WbfPolicies["is_update_task_enabled"] = "is_update_task_enabled";
    /**
   Allow to send a record to metroplus
   */ WbfPolicies["is_send_person_to_metroplus_enabled"] = "is_send_person_to_metroplus_enabled";
    /**
   Allow to see sms campaing by id
   */ WbfPolicies["is_get_s_m_s_campaign_by_id_enabled"] = "is_get_s_m_s_campaign_by_id_enabled";
    /**
   Allow to upload new files as attachments for personal document
   */ WbfPolicies["is_generate_pre_signed_url_for_document_enabled"] = "is_generate_pre_signed_url_for_document_enabled";
    /**
   Allow to create users
   */ WbfPolicies["is_create_user_enabled"] = "is_create_user_enabled";
    /**
   Allow to upload data using the data loader?
   */ WbfPolicies["is_persons_data_loader_enabled"] = "is_persons_data_loader_enabled";
    /**
   Allow to see a householder benestream person by id
   */ WbfPolicies["is_get_benestream_householder_person_by_id_enabled"] = "is_get_benestream_householder_person_by_id_enabled";
    /**
   Allow to see the list of the form templates available in the current organization
   */ WbfPolicies["is_get_organization_form_templates_enabled"] = "is_get_organization_form_templates_enabled";
    /**
   Allow to create email domains
   */ WbfPolicies["is_create_email_domain_enabled"] = "is_create_email_domain_enabled";
    /**
   Allow to create person using Data Loader
   */ WbfPolicies["is_persons_data_loader_create_enabled"] = "is_persons_data_loader_create_enabled";
    /**
   Allow to process and update elegibilities from csv file using Data Loader
   */ WbfPolicies["is_process_and_update_eligibilities_data_loader_csv_file_enabled"] = "is_process_and_update_eligibilities_data_loader_csv_file_enabled";
    /**
   Allow to see forms as a file
   */ WbfPolicies["is_get_forms_as_file_enabled"] = "is_get_forms_as_file_enabled";
    /**
   Allow to update benestream eligibilty guidelines
   */ WbfPolicies["is_update_benestream_eligibility_guideline_enabled"] = "is_update_benestream_eligibility_guideline_enabled";
    /**
   Allow to get all membership email domains by membership id
   */ WbfPolicies["is_get_all_membership_email_domains_by_membership_id_enabled"] = "is_get_all_membership_email_domains_by_membership_id_enabled";
    /**
   Allow to process ally health benefit utilization
   */ WbfPolicies["is_process_ally_health_benefit_utilization_enabled"] = "is_process_ally_health_benefit_utilization_enabled";
    /**
   Allow to update email templates
   */ WbfPolicies["is_update_email_template_enabled"] = "is_update_email_template_enabled";
    /**
   Allow to process and create enrollments from csv using Data Loader
   */ WbfPolicies["is_process_and_create_enrollments_data_loader_from_csv_enabled"] = "is_process_and_create_enrollments_data_loader_from_csv_enabled";
    /**
   Allow to remove an eligibility
   */ WbfPolicies["is_remove_eligibility_enabled"] = "is_remove_eligibility_enabled";
    /**
   Allow to see a call by id
   */ WbfPolicies["is_get_call_by_id_enabled"] = "is_get_call_by_id_enabled";
    /**
   Allow to see task
   */ WbfPolicies["is_get_task_enabled"] = "is_get_task_enabled";
    /**
   Allow to see documents by id
   */ WbfPolicies["is_get_document_by_id_enabled"] = "is_get_document_by_id_enabled";
    /**
   Allow to batch the mailchimp list
   */ WbfPolicies["is_batch_mailchimp_list_enabled"] = "is_batch_mailchimp_list_enabled";
    /**
   Allow to register metlife benfit utilization record
   */ WbfPolicies["is_register_metlife_benefit_utilization_record_enabled"] = "is_register_metlife_benefit_utilization_record_enabled";
    /**
   DEPRECATED - Will be deleted
   */ WbfPolicies["is_benestream_person_data_loader_get_data_loader_url_enabled"] = "is_benestream_person_data_loader_get_data_loader_url_enabled";
    /**
   Allow to drop a webhook voicemail
   */ WbfPolicies["is_drop_voicemail_webhook_enabled"] = "is_drop_voicemail_webhook_enabled";
    /**
   Allow to see an organization tags
   */ WbfPolicies["is_get_organization_tags_enabled"] = "is_get_organization_tags_enabled";
    /**
   Allow the enrollments reactivation process
   */ WbfPolicies["is_enrollments_reactivation_process_enabled"] = "is_enrollments_reactivation_process_enabled";
    /**
   Allow to activate an eligibility
   */ WbfPolicies["is_activate_eligibility_enabled"] = "is_activate_eligibility_enabled";
    /**
   Allow to register gvs benefit utilization record
   */ WbfPolicies["is_register_gvs_benefit_utilization_record_enabled"] = "is_register_gvs_benefit_utilization_record_enabled";
    /**
   Allow to see email templates
   */ WbfPolicies["is_get_email_templates_enabled"] = "is_get_email_templates_enabled";
    /**
   Allow to update a role
   */ WbfPolicies["is_update_role_enabled"] = "is_update_role_enabled";
    /**
   Allow to see associated benefit contracts by user
   */ WbfPolicies["is_get_associated_benefit_contracts_by_user_enabled"] = "is_get_associated_benefit_contracts_by_user_enabled";
    /**
   Allow bstm user to update bstm data from CSV - Data Loader
   */ WbfPolicies["is_benestream_person_data_loader_update_from_csv_enabled"] = "is_benestream_person_data_loader_update_from_csv_enabled";
    /**
   Allow to see tasks
   */ WbfPolicies["is_get_tasks_enabled"] = "is_get_tasks_enabled";
    /**
   Allow to update eligibility
   */ WbfPolicies["is_update_eligibility_enabled"] = "is_update_eligibility_enabled";
    /**
   Allow to batch mailchimp status
   */ WbfPolicies["is_batch_mailchimp_status_enabled"] = "is_batch_mailchimp_status_enabled";
    /**
   Allow to detach a policy
   */ WbfPolicies["is_detach_policy_enabled"] = "is_detach_policy_enabled";
    /**
   Allow to see aircall tags
   */ WbfPolicies["is_get_aircall_tags_enabled"] = "is_get_aircall_tags_enabled";
    /**
   Allow to download document attachments
   */ WbfPolicies["is_get_document_url_enabled"] = "is_get_document_url_enabled";
    /**
   Allow to attach a policy
   */ WbfPolicies["is_attach_policy_enabled"] = "is_attach_policy_enabled";
    /**
   Allow to delete person permanently
   */ WbfPolicies["is_person_permanent_delete_enabled"] = "is_person_permanent_delete_enabled";
    /**
   Allow to see benestream elegibility guideline by state name
   */ WbfPolicies["is_get_benestream_eligibility_guideline_by_state_name_enabled"] = "is_get_benestream_eligibility_guideline_by_state_name_enabled";
    /**
   Allow to see persons
   */ WbfPolicies["is_get_persons_enabled"] = "is_get_persons_enabled";
    /**
   Allow to generate enrollments url using Data Loader
   */ WbfPolicies["is_generate_enrollments_data_loader_upload_url_enabled"] = "is_generate_enrollments_data_loader_upload_url_enabled";
    /**
   Allow to add person income
   */ WbfPolicies["is_create_benestream_person_income_enabled"] = "is_create_benestream_person_income_enabled";
    /**
   Allow to create or update document (U360 Document scanner)
   */ WbfPolicies["is_create_or_update_document_by_type_enabled"] = "is_create_or_update_document_by_type_enabled";
    /**
   Allow to edit person income
   */ WbfPolicies["is_update_benestream_person_income_enabled"] = "is_update_benestream_person_income_enabled";
    /**
   Allow form submission notification
   */ WbfPolicies["is_notify_about_form_submission_enabled"] = "is_notify_about_form_submission_enabled";
    /**
   Allow to see policies
   */ WbfPolicies["is_get_policies_enabled"] = "is_get_policies_enabled";
    /**
   Allow to find duplicate persons
   */ WbfPolicies["is_get_duplicate_persons_enabled"] = "is_get_duplicate_persons_enabled";
    /**
   Allow to see person dependent income
   */ WbfPolicies["is_get_benestream_dependent_person_income_enabled"] = "is_get_benestream_dependent_person_income_enabled";
    /**
   Allow to update notes
   */ WbfPolicies["is_update_person_note_enabled"] = "is_update_person_note_enabled";
    /**
   Allow to update membership email domain
   */ WbfPolicies["is_update_membership_email_domain_enabled"] = "is_update_membership_email_domain_enabled";
    /**
   Allow to see notes
   */ WbfPolicies["is_get_person_notes_enabled"] = "is_get_person_notes_enabled";
    /**
   Allow to start sendgrid process
   */ WbfPolicies["is_start_sendgrid_process_enabled"] = "is_start_sendgrid_process_enabled";
    /**
   Allow to send emails
   */ WbfPolicies["is_send_email_to_person_enabled"] = "is_send_email_to_person_enabled";
    /**
   Allow to see office visits by id
   */ WbfPolicies["is_get_office_visit_by_id_enabled"] = "is_get_office_visit_by_id_enabled";
    /**
   Allow to create email templates
   */ WbfPolicies["is_create_email_template_enabled"] = "is_create_email_template_enabled";
    /**
   Allow to see users
   */ WbfPolicies["is_get_users_enabled"] = "is_get_users_enabled";
    /**
   Allow to see a householder benestream person
   */ WbfPolicies["is_get_benestream_person_householders_enabled"] = "is_get_benestream_person_householders_enabled";
    /**
   Allow to create a role
   */ WbfPolicies["is_create_role_enabled"] = "is_create_role_enabled";
    /**
   Allow to update data from CSV - Data Loader
   */ WbfPolicies["is_persons_data_loader_update_from_csv_enabled"] = "is_persons_data_loader_update_from_csv_enabled";
    /**
   Allow to see enrollment attachment
   */ WbfPolicies["is_get_enrollment_attachment_url_enabled"] = "is_get_enrollment_attachment_url_enabled";
    /**
   Allow to initialize all elegibilities
   */ WbfPolicies["is_initialize_all_eligibilities_enabled"] = "is_initialize_all_eligibilities_enabled";
    /**
   Allow to delete person income
   */ WbfPolicies["is_delete_benestream_person_income_enabled"] = "is_delete_benestream_person_income_enabled";
    /**
   Allow forms submission process
   */ WbfPolicies["is_process_form_submission_enabled"] = "is_process_form_submission_enabled";
    /**
   Allow to see voice mails
   */ WbfPolicies["is_get_voice_mails_enabled"] = "is_get_voice_mails_enabled";
    /**
   Allow to see roles
   */ WbfPolicies["is_get_roles_enabled"] = "is_get_roles_enabled";
    /**
   Allow to sync with nyc open data
   */ WbfPolicies["is_sync_n_y_c_open_data_enabled"] = "is_sync_n_y_c_open_data_enabled";
    /**
   Allow to generate images upload url for emails
   */ WbfPolicies["is_generate_upload_url_for_emails_images_enabled"] = "is_generate_upload_url_for_emails_images_enabled";
    /**
   Allow to see benestream person
   */ WbfPolicies["is_get_benestream_persons_enabled"] = "is_get_benestream_persons_enabled";
    /**
   Allow to create an enrollment
   */ WbfPolicies["is_create_enrollment_enabled"] = "is_create_enrollment_enabled";
    /**
   Allow User to see all other accounts, not assigned to him
   */ WbfPolicies["is_enable_accounts_not_assigned_to_user"] = "is_enable_accounts_not_assigned_to_user";
    /**
   Allow to update status of the Tasks
   */ WbfPolicies["is_enable_update_tasks"] = "is_enable_update_tasks";
    /**
   Allow to see all Tasks
   */ WbfPolicies["is_enable_all_tasks"] = "is_enable_all_tasks";
    /**
   Allow Tasks section, where the tasks assigned to the user are displayed
   */ WbfPolicies["is_enable_tasks_assigned_to_user"] = "is_enable_tasks_assigned_to_user";
    /**
   Allow user to see tlc in create lead page
   */ WbfPolicies["is_enable_create_lead_tlc_required"] = "is_enable_create_lead_tlc_required";
    /**
   Allow to see administration page
   */ WbfPolicies["is_enable_administration"] = "is_enable_administration";
    /**
   Allow to see benefit administration page
   */ WbfPolicies["is_enable_benefits_administration"] = "is_enable_benefits_administration";
    /**
   Allow to see reports page
   */ WbfPolicies["is_enable_reports"] = "is_enable_reports";
    /**
   Allow user to run data processing
   */ WbfPolicies["is_enable_data_processing"] = "is_enable_data_processing";
    /**
   Allow user to see the dashboard
   */ WbfPolicies["is_get_dashboard_enabled"] = "is_get_dashboard_enabled";
    /**
   Allow to disable PFML enrollment for a person in DU organization
   */ WbfPolicies["is_disable_du_pfml_enrollment_enabled"] = "is_disable_du_pfml_enrollment_enabled";
    /**
   Allow to see the field other email
   */ WbfPolicies["is_enable_other_email"] = "is_enable_other_email";
    /**
   
   */ WbfPolicies["is_enable_associated_benefit_contract_view"] = "is_enable_associated_benefit_contract_view";
    /**
   Allow user to edit email
   */ WbfPolicies["is_enable_email_edit"] = "is_enable_email_edit";
    /**
   Allow sync twilio sms with our service
   */ WbfPolicies["is_sync_sms_from_external_service_enabled"] = "is_sync_sms_from_external_service_enabled";
    /**
   Allow to see leads filter
   */ WbfPolicies["is_enable_leads_filter"] = "is_enable_leads_filter";
    /**
   Allow to see accounts filter
   */ WbfPolicies["is_get_persons_enabled_filter"] = "is_get_persons_enabled_filter";
    /**
   
   */ WbfPolicies["is_notespromptmodal_enabled"] = "is_notespromptmodal_enabled";
    /**
   Allow generate reports with a summary of all sms sent
   */ WbfPolicies["is_get_sms_report_usage_enabled"] = "is_get_sms_report_usage_enabled";
    /**
   Allow to see ESD/WA Submission
   */ WbfPolicies["is_wastate_view_enabled"] = "is_wastate_view_enabled";
    /**
   Allow to update ESD/WA Submission
   */ WbfPolicies["is_wastate_update_enabled"] = "is_wastate_update_enabled";
    /**
   Allow to generate WA/ESD report without ssn
   */ WbfPolicies["is_washington_state_build_report_without_ssn_enabled"] = "is_washington_state_build_report_without_ssn_enabled";
    /**
   Allow to delete user
   */ WbfPolicies["is_user_permanent_delete_enabled"] = "is_user_permanent_delete_enabled";
    /**
   Allow to merge persons
   */ WbfPolicies["is_merge_persons_enabled"] = "is_merge_persons_enabled";
    /**
   Allow to generate WA/ESD hashed report
   */ WbfPolicies["is_washington_state_build_hashed_report_du_esd_enabled"] = "is_washington_state_build_hashed_report_du_esd_enabled";
    /**
   Allow to generate WA/ESD report with unique ID, errors and without ssn
   */ WbfPolicies["is_washington_state_build_report_du_esd_without_ssn_enabled"] = "is_washington_state_build_report_du_esd_without_ssn_enabled";
    /**
   Allow to use documents update dataloader
   */ WbfPolicies["is_documents_data_loader_update_from_csv_enabled"] = "is_documents_data_loader_update_from_csv_enabled";
    /**
   Allow to get create a new tag for an organization
   */ WbfPolicies["is_create_tag_enabled"] = "is_create_tag_enabled";
    /**
   Authorizes global search for a user
   */ WbfPolicies["is_global_search_enabled"] = "is_global_search_enabled";
    /**
   Allow to process Matchback file
   */ WbfPolicies["is_washington_state_process_matchback_file_enabled"] = "is_washington_state_process_matchback_file_enabled";
    /**
   Allow to save files
   */ WbfPolicies["is_save_file_enabled"] = "is_save_file_enabled";
    /**
   Allow to generate WA/ESD report with SSN for Washington State
   */ WbfPolicies["is_washington_state_build_report_with_ssn_enabled"] = "is_washington_state_build_report_with_ssn_enabled";
    /**
   Allow user to show/hide the appointments widget.
   */ WbfPolicies["is_enable_view_appointments_widget"] = "is_enable_view_appointments_widget";
    /**
   Allow user to show/hide the Healthcare Screening section.
   */ WbfPolicies["is_enable_view_health_screening"] = "is_enable_view_health_screening";
    /**
   Allow the worker to see his benefits
   */ WbfPolicies["is_get_worker_benefits_enabled"] = "is_get_worker_benefits_enabled";
    /**
   Allow to use documents insert dataloader
   */ WbfPolicies["is_documents_data_loader_insert_from_csv_enabled"] = "is_documents_data_loader_insert_from_csv_enabled";
    /**
   Allow user to show/hide the communications widget/tab.
   */ WbfPolicies["is_enable_view_communication_tab"] = "is_enable_view_communication_tab";
    /**
   Allow user to generate AON Weekly Cleanup File
   */ WbfPolicies["is_aon_build_report_enabled"] = "is_aon_build_report_enabled";
    /**
   Allow to update AON/Metlife IDs
   */ WbfPolicies["is_aon_process_provider_resonance_enabled"] = "is_aon_process_provider_resonance_enabled";
    /**
   Allow to generate WA/ESD differences report.
   */ WbfPolicies["is_washington_state_build_differences_report_enabled"] = "is_washington_state_build_differences_report_enabled";
    /**
   is_enable_edit_policies_description
   */ WbfPolicies["is_enable_edit_policies_description"] = "is_enable_edit_policies_description";
    /**
   Allow to generate users login report
   */ WbfPolicies["is_organization_users_logins_report_enabled"] = "is_organization_users_logins_report_enabled";
    /**
   Allow to generate users activity report
   */ WbfPolicies["is_organization_user_activity_report_enabled"] = "is_organization_user_activity_report_enabled";
    /**
   Allow to process TNCs earnings report
   */ WbfPolicies["is_washington_state_process_tnc_earnings_file_enabled"] = "is_washington_state_process_tnc_earnings_file_enabled";
    /**
   Allow to generate ICESA file
   */ WbfPolicies["is_washington_state_build_icesa_file_enabled"] = "is_washington_state_build_icesa_file_enabled";
    /**
   Allow to generate earnings report
   */ WbfPolicies["is_washington_state_build_earnings_report_enabled"] = "is_washington_state_build_earnings_report_enabled";
    /**
   is_email_template_admin_feature_enabled
   */ WbfPolicies["is_email_template_admin_feature_enabled"] = "is_email_template_admin_feature_enabled";
    /**
   is_protectedtag_remove_enabled
   */ WbfPolicies["is_protectedtag_remove_enabled"] = "is_protectedtag_remove_enabled";
    /**
   Allow to generate full earnings report for a driver
   */ WbfPolicies["is_washington_state_build_full_driver_earnings_report_enabled"] = "is_washington_state_build_full_driver_earnings_report_enabled";
    /**
   Allow to get worker information (Current User/Person).
   */ WbfPolicies["is_get_worker_enabled"] = "is_get_worker_enabled";
    /**
   Allow to get tags for an organization
   */ WbfPolicies["is_get_tags_enabled"] = "is_get_tags_enabled";
    /**
   is_get_form_attachment_url_enabled
   */ WbfPolicies["is_get_form_attachment_url_enabled"] = "is_get_form_attachment_url_enabled";
    /**
   Allow to edit tags for an organization
   */ WbfPolicies["is_update_tag_enabled"] = "is_update_tag_enabled";
    /**
   Allow to delete tags for an organization
   */ WbfPolicies["is_remove_tag_enabled"] = "is_remove_tag_enabled";
    /**
   Allow user to show/hide the Form Submissions section.
   */ WbfPolicies["is_enable_view_form_submissions_tab"] = "is_enable_view_form_submissions_tab";
    /**
   Allow to see existing escalations in both the person profile task widget and in the escalations table
   */ WbfPolicies["is_get_escalations_enabled"] = "is_get_escalations_enabled";
    /**
   Allow user to search by provider external id
   */ WbfPolicies["is_provider_external_id_search_filter_enabled"] = "is_get_escalations_enabled";
})(WbfPolicies || (exports.WbfPolicies = WbfPolicies = {}));
//# sourceMappingURL=wbf-policies.js.map